import { ECGCaptureItem } from 'components';
import { useAppSelector } from 'hooks';
import React, { useCallback } from 'react';
import { DataStatus } from 'types/enums';
import styles from './styles.module.sass';

export const ECGCaptures = () => {
  const { analyzedEcgStatus, analyzedEcgCaptures } = useAppSelector((state) => state.requests);
  const isLoading = analyzedEcgStatus === DataStatus.LOADING;

  const generateCaptures = useCallback(() => {
    if (isLoading) {
      return <div>Loading...</div>;
    }
    if (!analyzedEcgCaptures || !analyzedEcgCaptures.length) {
      return <div>No captured data</div>;
    }

    return (
      <div>
        {analyzedEcgCaptures.map((capture) => (
          <ECGCaptureItem key={capture.id} {...capture} assessmentClass={styles.assessment} titleClass={styles.title} />
        ))}
      </div>
    );
  }, [analyzedEcgCaptures, isLoading]);

  return <div>{generateCaptures()}</div>;
};
